import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) {
      nav("/");
      return;
    }
    api.post("/auth/session", { session_id: sid })
      .then((r) => {
        setUser(r.data.user);
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        const pending = sessionStorage.getItem("teuralink_pending");
        nav(pending ? "/checkout" : "/dashboard");
      })
      .catch(() => nav("/"));
  }, [nav, setUser]);

  return (
    <div className="pt-40 text-center text-white/60 relative z-10">
      <Loader2 className="w-6 h-6 animate-spin inline text-gold" />
      <div className="mt-3">Establishing secure session…</div>
    </div>
  );
}
